import axios from "@/axios.js";
import CampaignFields from "./campaign_fields_service";

export default {
  getAllCampaignFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getAllCampaignFields(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  // getSelectedCampaignField({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     CampaignFields.getSelectedCampaignField(item, (rows, lastRow) => {
  //       // console.log(lastRow);
  //       resolve({ rows: rows, lastRow: lastRow });
  //     });
  //   });
  // },
  fetchFields(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/campaign_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeCampaignField(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/fields/campaign_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingFieldLists(context, field_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/campaign_fields/get_campaign_existing_field_lists/${field_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/campaign_fields/update_campaign_field", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/campaign_fields/add_fields", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeFields({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/fields/campaign_fields/${roleId}`)
        .then(response => {
          commit("REMOVE_STEPS", roleId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSelectedAccountCoreCampaignField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getSelectedAccountCoreCampaignField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getSelectedContactCoreCampaignField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getSelectedContactCoreCampaignField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getSelectedMasterCampaignField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getSelectedMasterCampaignField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getSelectedClientCampaignField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getSelectedClientCampaignField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getSelectedCampaignField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getSelectedCampaignField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getSelectedOpportunityField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getSelectedOpportunityField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getCascadedCampaignField({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignFields.getCascadedCampaignField(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getAllCampaignSelectedFieldsForExport(context, campaignId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/all_campaign_fields_for_export/${campaignId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
